import { Typography } from '@mui/material';
import { FeaturedIconOutlineIcon } from '../../assets/images';
import { MuiStack } from '../atoms/stackComponent';
import { MuiPopup } from './popupComponent';
export default function CancelSuccessfullyPopup(props) {
    var successfulPopup = props.successfulPopup, documentCode = props.documentCode, onClosePopup = props.onClosePopup, title = props.title, subTitle = props.subTitle;
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: successfulPopup,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            onClosePopup(false);
        },
        padding: '15px 0px 0px 15px',
        headerIcon: FeaturedIconOutlineIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: 'cancel-successfully-popup',
        flexDirection: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, title), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: '#6A7682',
        marginTop: 1
    }, subTitle)));
}
